<template>
	<div class="layout-preview-block"
	     ref="layout-preview-block">
		<div class="data-wrapper"
		     :data-specification="specification"
		     :data-category="category"
		     :data-id-area="idArea"
		     :data-id-objekt="idObject"
		     :data-bool-gattungsobjekt="isGenus">
			<erco-layout-divider-action-bar :prevSiteDataset="false"
				                            :nextSiteDataset="datasets[0]">
			</erco-layout-divider-action-bar>
			<div class="item-wrapper" v-for="dataset in datasets"
			                          :key="`{dataset.lang}${dataset.id}`"
			                          :data-dev-info="`{ type: 'module', id: '${dataset.id}', sitenumber: ${dataset.sitenumber}, topicId: '${dataset.topicId}', templateId: '${dataset.templateId}', templatePath: '${dataset.templatePath}' }`">
				<erco-layout-preview-item :dataset="dataset" :objecttype="objecttype" :objectname="objectname"></erco-layout-preview-item>
				<erco-layout-divider-action-bar :prevSiteDataset="dataset"
				                                :nextSiteDataset="getNextSiteDatasetAfter(dataset)">
				</erco-layout-divider-action-bar>
			</div>
		</div>
	</div>
</template>
<script>

import ErcoLayoutPreviewItem from '@/components/atoms/ErcoLayout/PreviewItem';
import ErcoLayoutDividerActionBar from '@/components/atoms/ErcoLayout/DividerActionBar';

export default {
	name: 'ErcoLayoutPreviewBlockMolecule',

	props: {
		datasets: {
			type: Array,
			required: true,
		},
	},

	computed: {
		objecttype() {
			return this.$store.state.objectsetup.current.FKM_Bereich;
		},
		objectname() {
			return this.$store.getters.objectname;
		},
		specification() {
			return this.$store.state.objectsetup.current.spezifikation_S_Platzhalter || '';
		},
		category() {
			return this.$store.state.objectsetup.current.S_Kurzbezeichnung_gattung || '';
		},
		idArea() {
			return parseInt(this.$store.state.objectsetup.current.FKM_Bereich, 10) || 0;
		},
		idObject() {
			return parseInt(this.$store.state.objectsetup.current.PKM_Objekt, 10) || 0;
		},
		isGenus() {
			return this.$store.state.objectsetup.current.B_Gattungsobjekt || '';
		},
	},

	methods: {
		getNextSiteDatasetAfter(dataset) {
			const currentSiteDatasetIndex = this.datasets.indexOf(dataset);

			if (currentSiteDatasetIndex > -1) {
				return (currentSiteDatasetIndex < this.datasets.length - 1) ?
							this.datasets[currentSiteDatasetIndex + 1] :
							false;
			}

			return null;
		},
	},

	components: {
		ErcoLayoutPreviewItem,
		ErcoLayoutDividerActionBar,
	},
};
</script>
<style lang="scss">
	@import url("//www.erco.com/cms.css");
</style>
<style lang="scss">

	.layout-preview-block {
	}

</style>



// WEBPACK FOOTER //
// PreviewBlock.vue?77747c65